import { render, staticRenderFns } from "./ssp-viewer-platforms-list.vue?vue&type=template&id=f5c4dfa0&scoped=true"
import script from "./ssp-viewer-platforms-list.vue?vue&type=script&lang=js"
export * from "./ssp-viewer-platforms-list.vue?vue&type=script&lang=js"
import style0 from "./ssp-viewer-platforms-list.vue?vue&type=style&index=0&id=f5c4dfa0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c4dfa0",
  null
  
)

export default component.exports